import React, { useState, useEffect } from "react";

const Notification = ({ message, type = "success", onClose }) => {
  // Définir les classes pour différents types de notifications
  const baseClasses =
    "fixed top-20 right-0 z-200 p-4 mt-4 rounded-md shadow-lg text-white transition-opacity duration-300";
  const typeClasses = {
    success: "bg-green-500",
    error: "bg-red-500",
    warning: "bg-yellow-500",
    info: "bg-blue-500",
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Notification disparaît après 3 secondes
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`${baseClasses} ${typeClasses[type]} opacity-100`}>
      {message}
    </div>
  );
};

export default Notification;
